import {useMemo} from "react";

import {useGuideState} from "@khan/guide-state";

/**
 * Returns a map of interactionIDs to image URLs for all images
 * in the guide state.
 */
export function useImagesMap() {
    const images = useGuideState("images");

    return useMemo(
        () =>
            new Map(
                images.map(({interactionID, imageURL, moderated}) => [
                    interactionID,
                    imageURL,
                ]),
            ),
        [images],
    );
}
